<template>
  <div class="jin-m-return">
    <div class="jin-m-container jin-return">
      <div @click="handleReturn">
        <Icon class="return" name="arrow-left" />
      </div>
      <div class="jin-return-title">
        <span v-if="title">
          {{ title }}
        </span>
        <van-dropdown-menu v-else active-color="#4777F4">
          <van-dropdown-item v-model="value" :title="`${option.find(item => item.value === value).text}${showKey}`" :options="option" @change="onChange" />
        </van-dropdown-menu>
      </div>
    </div>
  </div>
</template>

<script>
import { DropdownMenu, DropdownItem } from 'vant'

export default {
  components: {
    [DropdownMenu.name]: DropdownMenu,
    [DropdownItem.name]: DropdownItem
  },
  props: {
    title: {
      type: [String],
      default: ''
    },
    option: {
      type: Array,
      default: () => []
    },
    defaultValue: {
      type: [Number, String],
      default: 0
    },
    showKey: {
      type: String,
      default: '投递'
    },
    isFix: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      value: 0
    }
  },
  computed: {
    type() {
      return this.$route.query.type
    }
  },
  watch: {
    '$route.query.type'() {
      this.init()
    }
  },
  created() {
    // this.value = this.defaultValue
    this.init()
  },
  methods: {
    init() {
      if (this.$route.path.includes('resume')) {
        this.value = this.type === 'online' ? 0 : 1
      } else {
        this.value = this.$route.params.template
      }
    },
    handleReturn() {
      if (this.$route.name === 'RecruitResumeType' && this.$route.params.template !== 'ListInfo' && this.isFix) {
        this.Dialog.confirm({
          title: '提示',
          message: '信息尚未保存，是否确认退出页面？'
        })
          .then(() => {
            this.$router.go(-1)
          })
          .catch(() => {
            // on cancel
          })
      } else {
        this.$router.go(-1)
      }
    },
    onChange(v) {
      if (this.type) {
        const type = v ? 'upload' : 'online'
        this.$router.replace({
          path: '/list/resume/ListInfo',
          query: {
            ...this.$route.query,
            type
          }
        })
      }
      this.$emit('change', v)
    }
  }
}
</script>

<style lang="scss" scoped>
.jin {
  &-m-return {
    height: 43px;
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    z-index: 2021;
  }

  &-return {
    height: 43px;
    padding: 0 14px;
    display: flex;
    justify-content: center;
    align-items: center;
    background: #fff;

    i.return {
      position: absolute;
      top: 50%;
      left: 14px;
      transform: translateY(-50%);
    }

    &-title {
      font-weight: 500;
      font-size: 14px;

      /deep/ .van-dropdown {
        &-item {
          top: 43px !important;
        }

        &-menu__title {
          &::after {
            border-color: transparent transparent #3d4351 #3d4351;
          }

          &--active {
            &::after {
              border-color: transparent transparent rgb(71, 119, 244) rgb(71, 119, 244);
            }
          }
        }

        &-menu__bar {
          height: auto;
          box-shadow: none;
        }

        &-item__option {
          position: relative;
          padding: 16px 18px !important;

          &:nth-of-type(1) {
            border-top: 1px solid #e8e8ea;
          }

          &::after {
            left: 0;
            right: 0;
            border-bottom: 1px solid #e8e8ea;
            transform: scaleY(1);
          }

          .van-cell__title {
            display: flex;
            justify-content: center;
          }

          .van-cell__value {
            position: absolute;
            right: 18px;
            flex: none;
          }
        }
      }
    }
  }
}
</style>
